import React, { Fragment } from 'react';

import PropTypes from 'prop-types';
import DesktopWindow from './DesktopWindow';
import Footer from '../common/Footer';
import { useSelector } from 'react-redux';
import DesktopPopup from '../requestedDocuments/DesktopPopup';
export const POPUP_THANKYOU = 'showThankyouPopUp';
export default function DesktopMainPage(props) {
  const {
    actionDocument,
    popupId,
    onPopupClose,
    pageContent,
    children,
    pageFooterContent
  } = props;

  const caseName = useSelector(state => state.caseName);
  const companyName = useSelector(state => state.companyName);
  const companyEmail = useSelector(state => state.companyEmail);
  const companyLogo = useSelector(state => state.companyLogo);
  const endDate = useSelector(state => state.endDate);
  const expired = useSelector(state => state.expired);
  const brandingDetails = useSelector(state => state.brandingDetails);
  const scanEnded = useSelector(state => state.scanEnded);

  return (
    <Fragment>
      <DesktopWindow
        caseName={caseName}
        companyName={companyName}
        companyEmail={companyEmail}
        companyLogo={companyLogo}
        endDate={endDate}
        expired={expired}
        pageFooterContent={pageFooterContent}
        popup={
          popupId
            ? () => (
                <DesktopPopup
                  scanEnded={scanEnded}
                  popupId={popupId}
                  actionDocument={actionDocument}
                  companyName={companyName}
                  onPopupClose={onPopupClose}
                />
              )
            : null
        }
      >
        {pageContent ? pageContent : children}
      </DesktopWindow>

      <Footer
        customFooterText={brandingDetails.customFooterText}
        hideLogo={brandingDetails.hidePaperflyLogo}
      />
    </Fragment>
  );
}

DesktopMainPage.propTypes = {
  popupId: PropTypes.any,
  onPopupClose: PropTypes.func,
  pageContent: PropTypes.element,
  actionDocument: PropTypes.object,
  children: PropTypes.element,
  pageFooterContent: PropTypes.element
};
